import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import MediaServicesSpreadsheetIcon from '@atlaskit/icon/glyph/media-services/spreadsheet'
import DocumentsIcon from '@atlaskit/icon/glyph/documents'
import ImageIcon from '@atlaskit/icon/glyph/image'
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
 const getAttachIcon = (filePath) => {
    let type;
    if (!filePath) type = "undefined";
    const index = filePath.split("/");
    type = index[1]

    switch (type) {
      case "pdf":
        return <PictureAsPdfOutlinedIcon/>;
      case "excel":
        return <MediaServicesSpreadsheetIcon label="" />;
      case "word":
        return <DocumentsIcon label="" />;
      case "gif":
        return <ImageIcon label="" />;
      case "jpg":
        return <ImageIcon label="" />;
      case "jpeg":
        return <ImageIcon label="" />;
      case "png":
        return <ImageIcon label="" />;
      case "tiff":
        return <ImageIcon label="" />;
      case "xlsx":
        return <MediaServicesSpreadsheetIcon label=""/>;
      case "docx":
        return  <DocumentsIcon label="" />;
      case "undefined":
        return  <DocumentsIcon label="" />;
      default:
        return  <DocumentsIcon label="" />;
    }
  };

  const useStyles = makeStyles()((theme) => {
   return {
    file: {
        display: "flex!important",
        padding: "8px!important",
        borderRadius: "10px!important",
        position: "relative!important",
        [theme.breakpoints.down("600")]: {
          width: "95%!important",
        },
        [theme.breakpoints.down("400")]: {
          justifyContent: "center!important",
          alignItems: "center!important",
        },
      },
      deleteIcon: {
        position: "absolute!important",
        color: "red!important",
        left: "-8px!important",
        top: "-8px!important",
        cursor: "pointer!important",
      },
      fileIcon: {
        height: "45px!important",
        width: "45px!important",
        [theme.breakpoints.down("600")]: {
          width: "35%!important",
        },
        [theme.breakpoints.down("400")]: {
          justifyContent: "center!important",
          alignItems: "center!important",
        },
        "& > img": {
          height: "100%!important",
          width: "100%!important",
          [theme.breakpoints.down("400")]: {
            height: "auto!important",
          },
        },
      },
      fileName: {
        display: "flex!important",
        flexDirection: "column!important",
        width: "60%!important",
        [theme.breakpoints.down("600")]: {
          width: "50%!important",
        },
        "&  span": {
          display: "-webkit-box!important",
          overflow: "hidden!important",
          WebkitBoxOrient: "vertical!important",
          WebkitLineClamp: "1!important",
          textOverflow: "ellipsis!important",
          width: "80%!important",
        },
      },
      fileActionsIconBox:{
        position:"absolute!important",
        right:"0px!important",
        bottom:"-10px!important"
      },
   }
});
const ChatFileBox = ({file,handleDelete,isBase64}) => {
  const classes = useStyles();

  const convertBase64toFile = (base64String, fileName) => {
    const link = document.createElement('a');
    link.href = base64String;
    link.setAttribute('download', fileName);
    link.click();
    link.remove();
  };
 

  const downloadFile = (base64String, fileName) => {
    const parts = base64String.split(';base64,');
    const mimeType = parts[0].split(':')[1];
    const base64Data = parts[1];
    const byteCharacters = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
    const blob = new Blob([byteCharacters], { type: mimeType });
    const fileUrl = URL.createObjectURL(blob);
    convertBase64toFile(fileUrl, fileName);
  };

  

  const fileSize=`${(file?.size/ Math.pow(1024,2)).toFixed(2)} MB`
  
  return (
    <Box sx={{display: "grid!important",
    padding: "16px!important",
    borderRadius: "10px!important",
    position: "relative!important",
    color: isBase64 ? "#fff" : "#131519",
    }}>
      {handleDelete && !isBase64 && (
        <HighlightOffIcon
          className={classes.deleteIcon}
          onClick={handleDelete && handleDelete}
          label="" 
        />
     )} 
      <Box className={classes.fileIcon}>
        {isBase64 ? getAttachIcon(JSON.parse(file)?.oiriginalFile?.type) : getAttachIcon(file?.type )}

      </Box>
      <Box sx={{display: "grid"}}>
        <span  
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>{isBase64 ? JSON.parse(file)?.oiriginalFile?.name : file?.name }</span>
        {/* {!isBase64 && <span>{ `${file?.size} KB`}</span>} */}
        {!isBase64 && <span>{fileSize}</span>}

      </Box>
      {isBase64 && <Box sx={{display:"flex"}} > 
            <ArrowCircleDownIcon style={{marginRight: "10px"}} onClick={() =>
              downloadFile(JSON.parse(file)?.base64String, JSON.parse(file)?.oiriginalFile?.name)
            }/>
            <span>{ `${(JSON.parse(file)?.oiriginalFile?.size / Math.pow(1024,2)).toFixed(2)} MB`}</span>
        </Box>}
    </Box>
  );
};

export default ChatFileBox;